module.exports = __webpack_public_path__ + "static/media/sign.3fcd6777.jpg";